import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClienteService } from './clientes.service';
import { ToastService } from './toast.service';
import { Cliente } from '../models/cliente.model';
import { FormatadorHelper } from '../helpers/formatador.helper';
import { SeveridadeToast } from '../models/enums/severidade-toast.enum';
import { Observable, tap, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClienteSubmissionService {
  constructor(
    private clienteService: ClienteService,
    private toastService: ToastService,
    private router: Router
  ) {}

  submitCliente(
    cliente: Cliente,
    addComplete: (value: { cliente: Cliente }) => void,
    onError: (error: any) => void
  ) {
    this.clienteService.addCliente(cliente).subscribe({
      next: (cliente) => {
        this.toastService.setMensagemToast(
          'Cliente adicionado com sucesso.',
          SeveridadeToast.Success
        );
        addComplete({ cliente });
      },
      error: (error) => {
        if (error.status === 409) {
          this.toastService.setMensagemToast(
            'Já existe um cliente cadastrado com este CPF/CNPJ.',
            SeveridadeToast.Error
          );
        } else {
          this.toastService.setMensagemToast(
            'Erro ao adicionar o cliente.',
            SeveridadeToast.Error
          );
        }
        onError(error);
      },
      complete: () => this.router.navigate(['/clientes']),
    });
  }
  

  editCliente(clienteId: number, formValue: Cliente): Observable<Cliente> {
    formValue.cpfCnpj = FormatadorHelper.normalizarDocumento(formValue.cpfCnpj);
    const updatedCliente: Cliente = {
      id: clienteId,
      ...formValue,
    };
  
    return this.clienteService.updateCliente(updatedCliente).pipe(
      map(() => updatedCliente),
      tap(() => {
        this.toastService.setMensagemToast(
          'Cliente atualizado com sucesso.',
          SeveridadeToast.Success
        );
        this.router.navigate(['/clientes']);
      }),
      catchError((error) => {
        if (error.status === 409) {
          this.toastService.setMensagemToast(
            'Já existe um cliente cadastrado com este CPF/CNPJ.',
            SeveridadeToast.Error
          );
        } else {
          this.toastService.setMensagemToast(
            'Erro ao atualizar o cliente.',
            SeveridadeToast.Error
          );
        }
        throw error; 
      })
    );
  }
  
}
